import React from "react";
import SeoHead from "../components/Seo/SeoHead";
import RouteBuilder from "../components/RouteBuilder/RouteBuilder";
import { getCityPack } from "../data/routeBuilder";

export default function RouteBuilderPage() {
	const cityPack = getCityPack("nueva-york");

	if (!cityPack) return null;

	return (
		<>
			<SeoHead
				title="Crea tu ruta por Nueva York"
				description="Diseña una página bonita con tu ruta de viaje por Nueva York: elige lugares, personaliza y descárgala para Instagram Stories. Gratis con Viajes Molones."
				path="/crear-ruta"
			/>
			<RouteBuilder cityPack={cityPack} />
		</>
	);
}
